module.exports = __webpack_public_path__ + "static/media/documentation.5bcbe9a7.svg";